import { createHttpWithAuth } from "./httpWithAuth";
import { AuthClient } from "../types"; 
import { APIPATH } from '../App';

const httpWithAuth = createHttpWithAuth();

export function createAuthClient() {
    return new AuthClient(APIPATH, window as any);
}

export function createClient<T>(
    ClientType: new (baseUrl: string, http: any) => T
): T {
    return new ClientType(APIPATH, httpWithAuth);
}